import i18n from 'i18next'
import Backend from "i18next-xhr-backend";
import { initReactI18next } from 'react-i18next'
import tenantService from "/src/main/services/TenantService/TenantService";

const lang = readLanguageFromCookie();

i18n
    .use(Backend)
    .use(initReactI18next)
    .init({
        lng: lang,
        backend: {
          /* translation file path */
          loadPath: '/services/login/assets/i18n/{{ns}}/{{lng}}.json'
        },
        fallbackLng: 'en',
        debug: false,
        /* translations are default and also as fallback just because i18n cant handle async back call to determine the tenant */
        ns: ['translations'],
        fallbackNS: 'translations',
        defaultNS: 'translations',
        keySeparator: ".",
        interpolation: {
            escapeValue: false,
            formatSeparator: ','
        },
        react: {
          wait: true,
          useSuspense: true,
          transKeepBasicHtmlNodesFor: ["b", "strong", "span", "br"],
        }
    });

tenantService.getTenant().then((tenant) => {
  i18n.setDefaultNamespace(tenant.name);
  /* default language should be now set by the tenant service */
  const lang = readLanguageFromCookie();
  i18n.changeLanguage(lang);
});

window.addEventListener("languagechange", function (event) {
  const language = event.detail.language;
  i18n.changeLanguage(language).then(() => {});
});

function readLanguageFromCookie() {
    const cookies = document.cookie;
    const cookiearray = cookies.split(";");
    let language = "de";
    for (let i = 0; i < cookiearray.length; i++) {
        const name = cookiearray[i].split("=")[0];
        const value = cookiearray[i].split("=")[1];
        if (name.trim() === "Language" && /^[a-zA-Z]*$/.test(value)) {
            language = value;
        }
    }

    return language;
}
export default i18n;
